export default __webpack_public_path__ + "static/media/wfdsa_desktop.28838307.png";